import styled from 'styled-components'
import { media } from 'styles'

const StyledBasicModal = styled.div`
  padding: 5rem;
  text-align: center;

  img {
    width: 13rem;
    height: 13rem;
    margin-bottom: 3rem;
  }
  .fa {
    font-size: 10rem;
    margin-bottom: 3rem;
    &.error {
      color: red;
    }
    &.success {
      color: green;
    }
  }
  .message {
    margin: 0;
    font-size: 2.2rem;
  }

  ${media.mobile`
    padding: 1rem;
  `}
`

export default StyledBasicModal
